import { MypageNovelNovelIdChapterChapterIdPlatePlateIdDeleteInputModel } from "../../../../api/v1/mypage/novel/[novel_id]/chapter/[chapter_id]/plate/[plate_id]/DeleteInputModel"
import { deleteMypageNovelNovelIdChapterChapterIdPlatePlateId } from "../../../../api/v1/mypage/novel/[novel_id]/chapter/[chapter_id]/plate/[plate_id]/delete"

export const deleteChapterPlate = async (params: {
  plateId: number
  novelId: number
  chapterId: number
}): Promise<void> => {
  await deleteMypageNovelNovelIdChapterChapterIdPlatePlateId(
    new MypageNovelNovelIdChapterChapterIdPlatePlateIdDeleteInputModel(params),
  )
}
